var _rect, _path, _path2, _path3, _g, _path4, _g2, _path5, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirhomemobileicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7313 20.6156C25.7313 20.2076 25.8934 19.8163 26.1819 19.5278C26.4705 19.2393 26.8618 19.0772 27.2698 19.0772H45.7313C46.1394 19.0772 46.5307 19.2393 46.8192 19.5278C47.1077 19.8163 47.2698 20.2076 47.2698 20.6156V51.3849C47.2698 51.7929 47.1077 52.1842 46.8192 52.4727C46.5307 52.7612 46.1394 52.9233 45.7313 52.9233H27.2698C26.8618 52.9233 26.4705 52.7612 26.1819 52.4727C25.8934 52.1842 25.7313 51.7929 25.7313 51.3849V20.6156ZM27.2698 16.0002C26.0457 16.0002 24.8718 16.4865 24.0062 17.3521C23.1407 18.2176 22.6544 19.3916 22.6544 20.6156V51.3849C22.6544 52.6089 23.1407 53.7829 24.0062 54.6484C24.8718 55.514 26.0457 56.0002 27.2698 56.0002H45.7313C46.9554 56.0002 48.1294 55.514 48.9949 54.6484C49.8605 53.7829 50.3467 52.6089 50.3467 51.3849V20.6156C50.3467 19.3916 49.8605 18.2176 48.9949 17.3521C48.1294 16.4865 46.9554 16.0002 45.7313 16.0002H27.2698Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0681 49.2187C32.2345 49.0523 32.4603 48.9587 32.6957 48.9587H40.3034C40.5388 48.9587 40.7646 49.0523 40.9311 49.2187C41.0975 49.3852 41.191 49.6109 41.191 49.8463C41.191 50.0817 41.0975 50.3075 40.9311 50.4739C40.7646 50.6404 40.5388 50.7339 40.3034 50.7339H32.6957C32.4603 50.7339 32.2345 50.6404 32.0681 50.4739C31.9016 50.3075 31.8081 50.0817 31.8081 49.8463C31.8081 49.6109 31.9016 49.3852 32.0681 49.2187Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3489_15625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 35,
    width: 12,
    height: 4
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3144 37.9347C40.8806 36.5515 38.966 35.7786 36.9738 35.7786C34.9815 35.7786 33.0669 36.5515 31.6331 37.9347C31.5404 38.0378 31.4901 38.1722 31.4923 38.3108C31.4945 38.4495 31.549 38.5822 31.6449 38.6823C31.7409 38.7824 31.8711 38.8426 32.0096 38.8506C32.148 38.8587 32.2844 38.8142 32.3913 38.7259C33.6208 37.5375 35.2638 36.8732 36.9738 36.8732C38.6837 36.8732 40.3267 37.5375 41.5562 38.7259C41.658 38.8241 41.7938 38.8792 41.9353 38.8798C42.0093 38.8795 42.0825 38.8643 42.1505 38.835C42.2185 38.8057 42.2798 38.763 42.3309 38.7094C42.4311 38.6043 42.4856 38.4639 42.4825 38.3187C42.4794 38.1735 42.419 38.0355 42.3144 37.9347Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3489_15625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.4836,
    y: 35.751,
    width: 11.2897,
    height: 3.12091,
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3489_15625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 38,
    width: 8,
    height: 3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9945 38.5242C36.3309 38.5246 35.6741 38.6586 35.0634 38.9182C34.4526 39.1778 33.9004 39.5577 33.4396 40.0352C33.3894 40.0882 33.3502 40.1506 33.3242 40.2188C33.2981 40.287 33.2858 40.3596 33.2878 40.4326C33.2899 40.5056 33.3062 40.5774 33.3361 40.644C33.3659 40.7107 33.4085 40.7708 33.4615 40.8209C33.5686 40.9222 33.7116 40.9768 33.8589 40.9726C33.9319 40.9706 34.0037 40.9542 34.0704 40.9244C34.137 40.8946 34.1971 40.852 34.2472 40.7989C34.606 40.4267 35.0362 40.1306 35.512 39.9284C35.9878 39.7261 36.4995 39.6219 37.0165 39.6219C37.5335 39.6219 38.0452 39.7261 38.521 39.9284C38.9968 40.1306 39.4269 40.4267 39.7857 40.7989C39.8366 40.8508 39.8973 40.8921 39.9642 40.9204C40.0312 40.9487 40.1031 40.9635 40.1758 40.9638C40.2832 40.9634 40.3881 40.9315 40.4776 40.8721C40.567 40.8127 40.6371 40.7285 40.6792 40.6297C40.7213 40.5309 40.7335 40.4219 40.7144 40.3163C40.6952 40.2106 40.6455 40.1129 40.5714 40.0352C40.108 39.555 39.5522 39.1736 38.9375 38.9139C38.3227 38.6543 37.6618 38.5217 36.9945 38.5242Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3489_15625)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.45667,
    height: 2.72294,
    transform: "matrix(-1 0 0 1 40.7466 38.4963)",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3489_15625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 28,
    width: 14,
    height: 8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1357 35.0774C30.1357 35.2798 30.1357 35.3817 30.1996 35.4129C30.2636 35.4441 30.3442 35.3825 30.504 35.257L36.0485 30.9449C36.4974 30.5957 36.7218 30.4215 36.9827 30.4215C37.2437 30.4215 37.4681 30.5964 37.917 30.9449L43.4615 35.257C43.6213 35.3817 43.7019 35.4441 43.7658 35.4129C43.8297 35.3817 43.8297 35.2798 43.8297 35.0774V34.7663C43.8297 34.4011 43.8297 34.2185 43.7521 34.0603C43.6745 33.902 43.5308 33.7894 43.2424 33.5658L37.917 29.4233C37.4681 29.0741 37.2437 28.8999 36.9827 28.8999C36.7218 28.8999 36.4974 29.0749 36.0485 29.4233L30.7231 33.5658C30.4347 33.7894 30.2902 33.902 30.2133 34.0603C30.1365 34.2185 30.1357 34.4011 30.1357 34.7663V35.0774Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3489_15625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.1443,
    y: 28.8999,
    width: 13.6775,
    height: 6.51411,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirhomemobileicon);
export default __webpack_public_path__ + "static/media/airhomemobileicon.cda1b345c4092c0568fe8afdbd9923d2.svg";
export { ForwardRef as ReactComponent };